import './sass/main.scss';
import './js/preloader';
import './js/onSearchSubmit';
import './js/onLoadPage';
import './js/markup';
import './js/movieModal';
import './js/upBtn';
import './js/registration';
import './js/library-lists';
import './js/library-lists-updates';
import './js/nightMode';
import './js/alternate-pages';
import './js/modal-footer';
